import { stringRules } from './string';
import { numberRules } from './number';
import { arrayRules } from './array';
import { dateRules } from './date';
import { fileRules } from './file';
import { booleanRules } from './boolean';
import { conditionalRules } from './conditional';
import { RuleValidator } from '../types';

export const allRules: Record<string, RuleValidator> = {
    ...stringRules,
    ...numberRules,
    ...arrayRules,
    ...dateRules,
    ...fileRules,
    ...booleanRules,
    ...conditionalRules
};

export { stringRules, numberRules, arrayRules, dateRules, fileRules, booleanRules, conditionalRules };